import React from 'react';
import {
    Form,
    FormElement,
    Input,
    FormControl,
    FormHeader,
    FormHelperText,
    FormLabel,
    UseFormReturn,
} from '@fiverr-private/forms';
import { Container } from '@fiverr-private/layout_components';
import { Heading, Text, Typography } from '@fiverr-private/typography';
import { Button } from '@fiverr-private/button';
import { translate } from '../../../../../utils/translate';
import { FormSchema } from '../ResetPasswordStepForm.constants';
import { Variant } from '../../../../../shared/constants';
import { OnboardingFooter } from '../../../../OnboardingFooter';

interface InitialBodyProps {
    methods: UseFormReturn<FormSchema>;
    handleSubmit: ({ email }: FormSchema) => Promise<void>;
    variant?: Variant;
    goBack?: () => void;
}

export const InitialBody: React.FC<InitialBodyProps> = ({ handleSubmit, methods, variant, goBack }) => {
    const { isSubmitting, isValid } = methods.formState;
    const isOnboarding = variant === 'onboarding';

    const submitButton = (
        <Button loading={isSubmitting} disabled={!isValid} type="submit">
            {translate('steps.reset_password.submit')}
        </Button>
    );
    return (
        <Container display="flex" direction="column" flexGrow="1" minHeight={0}>
            <Form onSubmit={handleSubmit} methods={methods} flex="1" minHeight={0}>
                <Container padding="px" minHeight={0} overflowY="auto" maxWidth={isOnboarding ? '550px' : undefined}>
                    <Heading maxWidth={isOnboarding ? '550px' : undefined} as={isOnboarding ? 'h3' : 'h4'}>
                        {translate('steps.reset_password.title')}
                    </Heading>
                    <Text
                        maxWidth={isOnboarding ? '550px' : undefined}
                        marginTop="2"
                        marginBottom="8"
                        color="bodySecondary"
                    >
                        {translate('steps.reset_password.subtitle')}
                    </Text>

                    <FormControl name="email">
                        <FormHeader>
                            <FormLabel>
                                <Typography fontWeight="semibold" color="grey_1100">
                                    {translate('fields.reset_password_email.label')}
                                </Typography>
                            </FormLabel>
                        </FormHeader>
                        <FormElement>
                            <Input
                                type="email"
                                placeholder={translate('fields.reset_password_email.placeholder')}
                                autoComplete="email"
                                autoFocus
                            />
                        </FormElement>
                        <FormHelperText />
                    </FormControl>
                </Container>

                {isOnboarding ? (
                    <Container marginTop="auto">
                        <OnboardingFooter goBack={goBack}>{submitButton}</OnboardingFooter>
                    </Container>
                ) : (
                    <Container
                        marginTop={{ default: 'auto', md: '0' }}
                        display="flex"
                        direction="column"
                        alignItems="stretch"
                    >
                        {submitButton}
                    </Container>
                )}
            </Form>
        </Container>
    );
};
